/**
* 供货管理 供货商品管理
*/
<template>
  <div class="contianer">
    <!-- 我供货的 -->
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我供货的" name="first">
          <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="">
              <el-date-picker
                v-model="searchDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.seller_purchaser_name" clearable
                        placeholder="输入商家名称"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.product_name" clearable
                        placeholder="输入商品名称"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline.product_code" clearable
                        placeholder="输入商品编码"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline.status" placeholder="有效状态" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="有效" value="1"></el-option>
                <el-option label="无效" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search">查询</el-button>
              <el-button size="small" type="success" @click="addButton" class="add-button">新增</el-button>
              <el-button size="small" type="info" @click="editButton" class="edit-button">修改</el-button>
              <el-button size="small" type="warning" @click="exportExcel()">导出</el-button>
              <el-button size="small" type="primary" plain @click="refundNote">修改商品证件</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border @selection-change="handleSelectionChange"
                      @cell-dblclick="cellDbClick" element-loading-text="拼命加载中">
              <el-table-column align="center" type="selection" width="80">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="seller_purchaser_name" label="商家名称" min-width="160" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="product_name" label="商品名称" min-width="220" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="product_code" label="商品编码" min-width="220" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="standard_code" label="松佰标准编码" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="supplier_price" label="供货价格" width="120">
              </el-table-column>
              <el-table-column prop="status" label="有效状态" width="120">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="changeStatus(scope.row.id,scope.row.status)"
                    active-color="#409EFF">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column align="left" label="操作" width="160">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="viewPrice(scope.row.id)">
                    查看价格记录
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          <!-- 弹窗 -->
          <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
                     :title="dialogTitle"
                     :visible.sync="editDialogVisible"
                     width="32%"
                     :before-close="formHandleClose"
                     center>
            <el-form label-width="150px" :model="flashForm" :rules="rules" ref="flashForm" class="flashForm">
              <el-form-item label="商家名称" prop="seller_purchaser_id">
                <el-select v-model="flashForm.seller_purchaser_id" placeholder="请选择商家名称" clearable :disabled="isDisabled"
                           @change="changeProductName()">
                  <el-option class="sellerList"
                             v-for="item in sellerList"
                             :key="item.seller_purchaser_id"
                             :label="item.seller_purchaser_name"
                             :value="item.seller_purchaser_id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品来源" prop="radio" v-if="radioForm">
                <el-radio-group v-model="flashForm.radio" size="small" :disabled="isDisabled">
                  <el-radio :label="1">商品信息在对方</el-radio>
                  <el-radio :label="2" v-if="this.agent_type == '2891'">商品信息在我方</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="商家商品名称" prop="product_name" v-if="this.flashForm.radio == 1">
                <div style="display: flex;">
                  <el-input v-model="flashForm.product_name" auto-complete="off" clearable placeholder="请输入商家商品名称"
                            disabled>
                  </el-input>
                  <el-button size="small" type="success" style="margin-left: 20px" @click="querySearch" v-if="querch">查询</el-button>
                </div>
              </el-form-item>
              <el-form-item class="typn" label="供应商商品名称  （自营商品）" prop="product_name" v-if="this.flashForm.radio == 2">
                <div style="display: flex;">
                  <el-input v-model="flashForm.product_name" auto-complete="off" clearable placeholder="请输入供应商商品名称"
                            disabled>
                  </el-input>
                  <el-button size="small" type="success" style="margin-left: 20px" @click="querySearch1" v-if="querch">查询</el-button>
                </div>
              </el-form-item>
              <el-form-item label="供货价格" prop="supplier_price" class="r55 relative">
                  <el-input v-model="flashForm.supplier_price" auto-complete="off" clearable placeholder="请输入供货价格">
                  </el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="sure('flashForm')" :disabled="!isCanSubmit">确 定</el-button>
              <el-button @click="formHandleClose">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 商家商品销售名称-选择商品-->
          <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
                     title="选择商品"
                     :visible.sync="productDialogVisible"
                     width="40%"
                     top="6vh"
                     :before-close="prodHandleClose"
                     center>
            <!--列表-->
            <div style="height: 530px;overflow-y: auto">
              <el-form :inline="true" :model="productFormInline" class="user-search">
                <el-form-item label="">
                  <el-input size="small" v-model="productFormInline.product_name" placeholder="商品名称"
                            clearable></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" v-model="productFormInline.code" placeholder="松佰商品标准编码/供应商商品编码"
                            clearable style="width: 248px"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="small" type="primary" @click="productSearch">查询</el-button>
                </el-form-item>
              </el-form>
              <el-table size="small" :data="productListData" highlight-current-row v-loading="loading" border
                        @cell-dblclick="cellDbClick" @selection-change="infoHandleSelectionChange"
                        :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                        element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column align="center" type="selection" width="60">
                </el-table-column>
                <el-table-column
                  label="序号"
                  width="60">
                  <template slot-scope="scope">
                    {{productpageparm.pageSize * (productpageparm.currentPage - 1) + (scope.$index + 1)}}
                  </template>
                </el-table-column>
                <el-table-column prop="product_name" label="商品名称" min-width="180" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column prop="standard_code" label="松佰商品标准编码" min-width="180" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column prop="product_code" label="供应商商品编码" min-width="180" :show-overflow-tooltip='true'>
                </el-table-column>
              </el-table>
            </div>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="productpageparm" @callFather="productCallFather"></Pagination>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="sureRonous()">确 认</el-button>
              <el-button @click="prodHandleClose()">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 供应商商品销售名称-选择商品-->
          <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
                     title="选择商品"
                     :visible.sync="supplierDialogVisible"
                     width="40%"
                     top="6vh"
                     :before-close="prodHandleClose1"
                     center>
            <!--列表-->
            <div style="height: 530px;overflow-y: auto">
              <el-form :inline="true" :model="productFormInline1" class="user-search">
                <el-form-item label="">
                  <el-input size="small" v-model="productFormInline1.product_name" placeholder="商品名称"
                            clearable></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" v-model="productFormInline1.code" placeholder="松佰商品标准编码/供应商商品编码"
                            clearable style="width: 248px"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="small" type="primary" @click="productSearch1">查询</el-button>
                </el-form-item>
              </el-form>
              <el-table size="small" :data="productListData1" highlight-current-row v-loading="loading" border
                        @cell-dblclick="cellDbClick" @selection-change="infoHandleSelectionChange1"
                        :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                        element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column align="center" type="selection" width="60">
                </el-table-column>
                <el-table-column
                  label="序号"
                  width="60">
                  <template slot-scope="scope">
                    {{productpageparm1.pageSize * (productpageparm1.currentPage - 1) + (scope.$index + 1)}}
                  </template>
                </el-table-column>
                <el-table-column prop="product_name" label="商品名称" min-width="180" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column prop="standard_code" label="松佰商品标准编码" min-width="180" :show-overflow-tooltip='true'>
                </el-table-column>
                <el-table-column prop="product_code" label="供应商商品编码" min-width="180" :show-overflow-tooltip='true'>
                </el-table-column>
              </el-table>
            </div>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="productpageparm1" @callFather="productCallFather1"></Pagination>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="sureRonous1()">确 认</el-button>
              <el-button @click="prodHandleClose1()">取 消</el-button>
            </span>
          </el-dialog>
        </el-tab-pane>

        <!-- 给我供货 -->
        <el-tab-pane label="给我供货" name="second" v-if="agent_type=='2891'">
          <el-form :inline="true" :model="formInline1" class="user-search">
            <el-form-item label="">
              <el-date-picker
                v-model="searchDate1"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.seller_supplier_name" clearable
                        placeholder="输入供应商名称"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.product_name" clearable
                        placeholder="输入商品名称"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input size="small" v-model="formInline1.product_code" clearable
                        placeholder="输入商品编码"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline1.status" placeholder="有效状态" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="有效" value="1"></el-option>
                <el-option label="无效" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="search1">查询</el-button>
              <el-button size="small" type="warning" @click="exportExcel1()">导出</el-button>
            </el-form-item>
          </el-form>
          <!--列表-->
          <div style="height: 550px;overflow-y: auto">
            <el-table size="small" :data="listData1" highlight-current-row v-loading="loading" border @selection-change="handleSelectionChange"
                      @cell-dblclick="cellDbClick" element-loading-text="拼命加载中">
              <el-table-column align="center" type="selection" width="80">
              </el-table-column>
              <el-table-column
                label="序号"
                width="60">
                <template slot-scope="scope">
                  {{pageparm1.pageSize * (pageparm1.currentPage - 1) + (scope.$index + 1)}}
                </template>
              </el-table-column>
              <el-table-column prop="seller_supplier_name" label="供应商名称" min-width="160" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="product_name" label="商品名称" min-width="220" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="product_code" label="商品编码" min-width="220" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="standard_code" label="松佰标准编码" width="180" :show-overflow-tooltip='true'>
              </el-table-column>
              <el-table-column prop="supplier_price" label="供货价格" width="120">
              </el-table-column>
              <el-table-column prop="status" label="有效状态" width="120">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="changeStatus(scope.row.id,scope.row.status)"
                    active-color="#409EFF">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column align="left" label="操作" width="160">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="viewPrice(scope.row.id)">
                    查看价格记录
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
        </el-tab-pane>
      </el-tabs>
      <!-- 价格历史 -->
      <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
                 title="查看价格记录"
                 :visible.sync="priceDialogVisible"
                 width="30%"
                 class="price"
                 center>
        <el-timeline>
          <el-timeline-item color="#0bbd87"
                            v-for="(item, index) in priceList"
                            :key="index"
                            :timestamp="item.create_time">
            <div>价格：￥{{item.supplier_price}}</div>
            <div>操作人：{{item.operator}}</div>
          </el-timeline-item>
        </el-timeline>
      </el-dialog>
      <!--修改商品证件-->
      <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
                 title="修改商品证件" :before-close="handleClose"
                 :visible.sync="refundDialogVisible"
                 width="40%"
                 center>
        <el-form label-width="120px" :model="refundForm" ref="refundForm" class="editPaidForm">
          <el-form-item label="商品证件图片" class="ids">
            <el-upload :multiple="true"
                       action="#" ref="upload"
                       list-type="picture-card"
                       :http-request="uploadFile"
                       :before-upload="beforeUpload"
                       :file-list="productCredentialImgFilesList"
                       :on-remove="handleCredentialRemove"
                       :on-preview="handlePictureCardPreview">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-dialog :visible.sync="pictureDialogVisible" :modal="false">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
          <div style="text-align: center;color: #F31B1B" v-if="isShowTip">{{isShowTipMessage}}</div>
          <div style="text-align: center;color: #D9001B">单张图片大小不得超过1M，仅支持jpg、jpeg、png格式</div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">关 闭</el-button>
            <el-button type="primary" @click="refundEditPaid('refundForm')" :disabled="!isCanSubmit">确 定</el-button>
      </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  productSupplyExport,
  productPurchaseExport,
  supplierProductList, agentProductUpdate,
  supplierProductAll,
  agentProductAdd,
  purchaserSupplierAudit, putawayedProduct, productUpdateStatus, productPurchaseList,
  productPriceLog, updateLicenses, selfPutawayedProduct
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate, uploadFile} from "../../utils/util";
  import {getToken} from "../../api/commonMG";

  export default {
    data: () => {
      var validateSalePrice = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入供货价格'));
        } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value))) {
          return callback(new Error('输入长度过长或格式不正确'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, // 是显示加载
        editDialogVisible: false, //控制页面显示与隐藏
        priceDialogVisible: false,
        refundDialogVisible: false,
        dialogTitle: '',  // 标题
        searchDate: '',
        searchDate1: '',
        selectTableData: [],
        querch: false,
        formInline: {
          page: 1,
          rows: 10,
          begin_time: '',
          end_time: '',
          seller_purchaser_name: '',
          product_name: '',
          product_code: '',
          status: ''
        },
        formInline1: {
          page: 1,
          rows: 10,
          begin_time: '',
          end_time: '',
          seller_supplier_name: '',
          product_name: '',
          product_code: '',
          status: ''
        },
        productFormInline: {
          page: 1,
          rows: 10,
          product_name: "",
          code: ""
        },
        productFormInline1: {
          page: 1,
          rows: 10,
          seller_purchaser_id: "",
          product_name: "",
          // seller_supplier_name: "",
          code: ""
        },
        refundForm: {
          ids: [],
        },
        ids: '',
        tokenId: '',
        activeName: 'first',
        listData: [], //用户数据
        listData1: [], //用户数据
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页的数据条数
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pageparm1: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        productpageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        productpageparm1: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        flashForm: {
          seller_purchaser_id: '',
          product_id:'',
          product_name:'',
          supplier_price:'',
          radio: '',
          is_zb: ''
        },
        editForm: {
          id:'',
          supplier_price:''
        },
        // rules表单验证
        rules: {
          radio: [{required: true, message: '请选择商品来源', trigger: 'change'}],
          seller_purchaser_id: [{required: true, message: '请选择销售商名称', trigger: 'blur'}],
          product_name: [{required: true, message: '请选择商品', trigger: 'blur'}],
          supplier_price: [{required: true, validator: validateSalePrice, trigger: 'blur'}],
        },
        sellerList: [],
        isCanSubmit: true,
        confirmTip: '',
        productDialogVisible: false,
        supplierDialogVisible: false,
        productListData: [],
        productListData1: [],
        infoSelectTableData: [],
        issureRonous: false,
        isDisabled:false,
        priceList:[],
        agent_type: localStorage.getItem('agent_type')||'2891',
        imgUrl: '',
        imgId: '',
        productCredentialImgFilesList: [],//修改时已有图片的数组
        productCredentialImageUrl: [],//新增商品图片数组
        dialogImageUrl: '',
        pictureDialogVisible: false,
        isShowTip: false,
        isShowTipMessage: '',
        radioForm: true
      };
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getData(this.formInline)
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表1-0
      getData() {
        this.loading = true
        supplierProductList(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      addButton() {
        this.editDialogVisible = true;
        this.dialogTitle = '新增供货商品';
        this.flashForm = {
          seller_purchaser_id: '',
          product_id:'',
          product_name:'',
          supplier_price:'',
          radio: 1,
        };
        this.isDisabled = false;
        this.querch = true;
        this.getProductAll()
      },
      getProductAll() {
        supplierProductAll()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.sellerList = res.content;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      changeProductName() {
        this.sellerList.forEach((item) => {
          if (item.seller_purchaser_id == this.flashForm.seller_purchaser_id) {
            this.flashForm.is_zb = item.is_zb
            if (this.flashForm.is_zb == '0') {
              this.flashForm.radio = 1;
              this.radioForm = true
            } else {
              this.radioForm = false
            }
          }
        })
      },
      // 修改弹窗
      editButton() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].product_seller_id === this.selectTableData[0].seller_purchaser_id) {
          this.flashForm.radio = 1
        } else {
          this.flashForm.radio = 2
        }
        this.editForm.id = this.selectTableData[0].id;
        this.flashForm.seller_purchaser_id = this.selectTableData[0].seller_purchaser_name;
        this.flashForm.product_name = this.selectTableData[0].product_name;
        this.flashForm.supplier_price = this.selectTableData[0].supplier_price;
        this.editDialogVisible = true;
        this.dialogTitle = '修改供货商品';
        this.isDisabled = true;
        this.querch = false;
      },
      sure(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if(this.dialogTitle=='新增供货商品') {
              agentProductAdd(this.flashForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '保存成功!'
                    })
                    this.editDialogVisible = false;
                    this.getData(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.editForm.supplier_price = this.flashForm.supplier_price;
              agentProductUpdate(this.editForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '保存成功!'
                    })
                    this.editDialogVisible = false;
                    this.getData(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getData(this.formInline)
      },
      // 获取公司列表1-1
      getData1() {
        this.loading = true
        productPurchaseList(this.formInline1)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData1 = res.content.rows
              // 分页赋值
              this.pageparm1.currentPage = this.formInline1.page
              this.pageparm1.pageSize = this.formInline1.rows
              this.pageparm1.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather1(parm) {
        this.formInline1.page = parm.currentPage
        this.formInline1.rows = parm.pageSize
        this.getData1(this.formInline1)
      },
      // 搜索事件
      search() {
        if (this.searchDate) {
          this.formInline.begin_time = timestampToDate(this.searchDate[0])
          this.formInline.end_time = timestampToDate(this.searchDate[1])
        } else {
          this.formInline.begin_time = ''
          this.formInline.end_time = ''
        }
        this.formInline.page = 1;
        this.getData(this.formInline)
      },
      search1() {
        if (this.searchDate1) {
          this.formInline1.begin_time = timestampToDate(this.searchDate1[0])
          this.formInline1.end_time = timestampToDate(this.searchDate1[1])
        } else {
          this.formInline1.begin_time = ''
          this.formInline1.end_time = ''
        }
        this.formInline1.page = 1;
        this.getData1(this.formInline1)
      },
      // 查询-商品销售名称列表
      querySearch() {
        if(!this.flashForm.seller_purchaser_id) {
          this.$message.error('销售商名称不能为空！')
          return
        }
        this.productDialogVisible = true;
        this.productFormInline.seller_purchaser_id = this.flashForm.seller_purchaser_id;
        this.getProductData()
      },
      prodHandleClose() {
        this.productFormInline = {
          page: 1,
          rows: 10,
          product_name: "",
          code: ""
        }
        this.productDialogVisible = false
        this.getProductData()
      },
      // 商家商品销售名称-搜索事件
      productSearch() {
        this.productFormInline.page = 1;
        this.getProductData(this.productFormInline)
      },
      // 商家商品销售名称-选择商品列表
      getProductData() {
        this.loading = true
        putawayedProduct(this.productFormInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.productListData = res.content.rows
              // 分页赋值
              this.productpageparm.currentPage = this.productFormInline.page
              this.productpageparm.pageSize = this.productFormInline.rows
              this.productpageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      productCallFather(parm) {
        this.productFormInline.page = parm.currentPage
        this.productFormInline.rows = parm.pageSize
        this.getProductData(this.productFormInline.activity_area_sort_id)
      },
      infoHandleSelectionChange(val) {
        this.infoSelectTableData = val;
        this.flashForm.product_name = val.map(item => item.product_name).join(',');
        this.flashForm.product_id = val.map(item => item.product_id).join(',');
      },
      sureRonous() {
        if (this.infoSelectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.infoSelectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productDialogVisible = false;
        this.issureRonous = true;
      },
      // 查询-供应商销售名称列表
      querySearch1() {
        if(!this.flashForm.seller_purchaser_id) {
          this.$message.error('销售商名称不能为空！')
          return
        }
        this.supplierDialogVisible = true;
        this.productFormInline1.seller_purchaser_id = this.flashForm.seller_purchaser_id;
        this.getProductData1()
      },
      prodHandleClose1() {
        this.productFormInline1 = {
          page: 1,
          rows: 10,
          seller_purchaser_id: "",
          product_name: "",
          code: ""
        }
        this.supplierDialogVisible = false
        this.getProductData()
      },
      // 供应商商品销售名称-搜索事件
      productSearch1() {
        this.productFormInline1.page = 1;
        this.getProductData1(this.productFormInline1)
      },
      // 供应商商品销售名称-选择商品列表
      getProductData1() {
        this.loading = true
        selfPutawayedProduct(this.productFormInline1)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.productListData1 = res.content.rows
              // 分页赋值
              this.productpageparm1.currentPage = this.productFormInline1.page
              this.productpageparm1.pageSize = this.productFormInline1.rows
              this.productpageparm1.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      productCallFather1(parm) {
        this.productFormInline1.page = parm.currentPage
        this.productFormInline1.rows = parm.pageSize
        this.getProductData1(this.productFormInline1.activity_area_sort_id)
      },
      infoHandleSelectionChange1(val) {
        this.infoSelectTableData = val;
        this.flashForm.product_name = val.map(item => item.product_name).join(',');
        this.flashForm.product_id = val.map(item => item.product_id).join(',');
      },
      // 供应商商品销售名称-查询
      sureRonous1() {
        if (this.infoSelectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.infoSelectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.supplierDialogVisible = false;
        this.issureRonous = true;
      },
      handleClick(tab, event) {
        console.log(tab.index)
        if (tab.index == 0) {
          this.getData(this.formInline)
        } else if (tab.index == 1) {
          this.getData1(this.formInline1)
        }
      },
      checkDate(date) {
        if (/^(\d{4})-(\d{2})-(\d{2})$/.test(date)) {
          return true
        } else {
          return false
        }
      },
      //每页条数改变时触发 选择一页显示多少行
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      handleSizeChange1(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      //当前页改变时触发 跳转其他页
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      handleCurrentChange1(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      handleCurrentChange2(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      // 导出
      exportExcel() {
        productSupplyExport(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '我供货的商品信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 导出明细
      exportExcel1() {
        productPurchaseExport(this.formInline1)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '给供货的商品信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      viewPrice(id) {
        let body = {
          id:id
        }
        console.log(this.priceDialogVisible)
        productPriceLog(body).then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.priceDialogVisible = true;
            this.priceList = res.content;
          }
        })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      audit(id, audit_status) {
        if (audit_status == '261') {
          this.confirmTip = '是否同意该供货商的申请？'
        } else {
          this.confirmTip = '是否拒绝该供货商的申请？'
        }
        this.$confirm(this.confirmTip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let body = {
              id: id,
              audit_status: audit_status
            }
            purchaserSupplierAudit(body).then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                if (audit_status == '261') {
                  this.$message({
                    type: 'success',
                    message: '已同意该供货商的申请'
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '已拒绝该供货商的申请'
                  })
                }
                this.getData(this.formInline1)
              }
            })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      // 无效有效状态
      changeStatus(id, status) {
        if (!status) {
          let body = {
            id: id,
            status: 0
          }
          productUpdateStatus(body)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getData(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          let body = {
            id: id,
            status: 1
          }
          productUpdateStatus(body)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getData(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      // 修改商品证件
      refundNote() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        let hasInvalidStatus = false;
        this.selectTableData.forEach((item) => {
          if (item.status === 0 &&!hasInvalidStatus) {
            this.$message.error('无效状态下的商品不允许修改商品证件');
            hasInvalidStatus = true;
            return;
          }
        });
        if (hasInvalidStatus) {
          return;
        };
        this.refundDialogVisible = true;
        this.refundForm.ids = [];
        this.refundForm.ids = this.selectTableData[0].ids;
      },
      //关闭弹窗时的操作
      handleClose() {
        this.$refs["refundForm"].resetFields();
        this.$refs.upload.clearFiles()
        this.refundDialogVisible = false;
        this.productCredentialImgFilesList = [];
        this.productCredentialImageUrl = [];
      },
      formHandleClose() {
        this.$refs["flashForm"].resetFields();
        this.editDialogVisible = false;
      },
      // 修改商品证件-确认
      refundEditPaid() {
        this.loading = true;
        this.refundForm.ids = [];
        this.selectTableData.forEach((item) => {
          this.refundForm.ids.push(item.id)
        });
        let parameter = {
          ids: this.refundForm.ids,
          licenses: this.productCredentialImageUrl
        }
        updateLicenses(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功修改商品证件！'
              })
              this.handleClose()
              this.search();
            }
          })
          .catch(err => {
            this.loading = false
          })
      },
      handleRemove(file) {
        console.log(file);
      },
      // 可以获取图片参数
      handleUpload(file) {
        console.log(file)
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.pictureDialogVisible = true;
      },
      handleCredentialRemove(file) {
        if (file.id) {
          this.productCredentialImgFilesList.forEach((item, index) => {
            if (file.id == item.id) {
              this.productCredentialImgFilesList.splice(index, 1);
            }
          })
        } else {
          this.productCredentialImageUrl.forEach((item, index) => {
            if (file.uid == item.uid) {
              this.productCredentialImageUrl.splice(index, 1);
            }
          })
        }
      },
      beforeUpload(file) {
        if (this.checkPic(file, 'isShowTip')) {
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                let data = {
                  img_id: "",
                  img_url: res.data.content.file.fileUrl
                }
                this.productCredentialImageUrl.push(data);
              })
            }
          });
        } else {
          return false
        }
      },
      // 检验照片
      checkPic(file, type) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png" || file.type == "image/jpg";
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.isShowTipMessage = '上传图片仅支持jpg、jpeg、png格式!';
          let that = this;
          if (type == 'isShowTip') {
            this.isShowTip = true;
            setTimeout(function () {
              that.isShowTip = false
            }, 5000)
            return false
          }
        } else if (!isLt1M) {
          this.isShowTipMessage = '上传图片大小不能超过 1MB!'
          let that = this;
          if (type == 'isShowTip') {
            this.isShowTip = true;
            setTimeout(function () {
              that.isShowTip = false
            }, 5000)
            return false
          }
        } else {
          return true
        }
      },
      uploadFile(file) {
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.seller_purchaser_name == cell.innerText || row.product_name == cell.innerText || row.product_code == cell.innerText || row.seller_supplier_name == cell.innerText || row.standard_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  };
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 120px;
    width: 320px;
    resize: none;
  }

  /deep/ .flashForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  .sellerList {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 320px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  /deep/ .flashForm .el-input--suffix {
    width: 320px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader {
    height: 148px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  /deep/ .price .el-dialog__body {
    max-height: 400px;
    overflow: auto;
  }

  /deep/ .typn .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/views/supply/supplyGood.vue